import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { themeColor } from '../../../Theming';

const Button = styled.button`
  transition: all 0.2s ease-in-out 0s;
  width: 300px;
  background-color: ${themeColor('green')};
  margin-bottom: 45px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    background-color: ${themeColor('grey')};
  }
`;

type Button1Props = {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  className?: string;
  id?: string;
} & React.CSSProperties;

const Button1: React.FC<PropsWithChildren<Button1Props>> = ({
  borderRadius = '1rem',
  padding = '.5rem 1.5rem',
  border = 'none',
  fontWeight = 'bold',
  cursor = 'pointer',
  onClick,
  disabled,
  children,
  id,
  ...rest
}) => {
  return (
    <Button id={id} disabled={disabled} onClick={onClick} style={{ ...rest }}>
      {children}
    </Button>
  );
};

export default Button1;
